import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import sutherlandLogo from '../assets/img/sutherlandglobal.png';
import eventLogo from '../assets/img/Lumina-event.png';
import eSeallogo from '../assets/img/big-logo.png'
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useRef } from "react";
import LUMINA_EVENT_CONFIG from "utilities/luminaEventConfig";
import { BiQrScan } from "react-icons/bi";
import { FiUser, FiCalendar, FiClock, FiMapPin } from "react-icons/fi";


export function EventPassPage() {
  const { city } = useParams();
  const eventDetails = LUMINA_EVENT_CONFIG[city?.toLowerCase()];
  const entryPassRef = useRef(null);
  const [qrCode, setQrCode] = useState(null);
  const [employeeId, setEmployeeId] = useState("");
   const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [validationType, setValidationType] = useState("id"); 
  const [email, setEmail] = useState("");
   const [emailError, setEmailError] = useState("");
   const [isFlipping, setIsFlipping] = useState(false);
  const [employeeName, setEmployeeName] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [isSaved, setIsSaved] = useState(false);

  const handleValidate = async () => {
    if (!employeeId && !email) {
      return; // Nothing to validate
    }
    setLoading(true);
    setError(null);

    const empCodeValue = employeeId ? employeeId : email;

    if (validationType === "email") {
      if (!email.trim()) {
        setEmailError("Please enter your Email");
        return;
      }
      // simple regex for validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        setEmailError("Please enter a valid Email address");
        return;
      }
    }

    try {
      const response = await fetch("https://product-stg.eseal.io:5003/product/v1/qrcode", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          emp_code: empCodeValue || null,
        })
      });

      if (!response.ok) {
        throw new Error(`API error: ${response.status}`);
      }

      const data = await response.json();
      if (data.qrcode) {
        setQrCode(data.qrcode);
        setEmployeeName(data.emp_name || "");
      } else {
        throw new Error(`${data.message}`);
      }
    } catch (err) {
      setQrCode(null);
      setError(err.message || "Failed to fetch QR Code");
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
  const { name, value } = e.target;
  if (name === "employeeId") {
    setEmployeeId(value);
    if (value) setEmail("");
    setEmailError("");
  } else if (name === "email") {
    setEmail(value);
    if (value) setEmployeeId("");
    setEmailError(value.trim() === "" ? null : "");
  } else if (name === "validationType") {
    setValidationType(value);
    setEmployeeId("");
    setEmail("");
    setEmailError("");
  }
};


// const handleDownloadPDF = async () => {
//   setIsSaving(true);
//   setIsSaved(false);

//   if (!entryPassRef.current) {
//     setIsSaving(false);
//     return;
//   }

//   const element = entryPassRef.current;

//   // Store existing responsive styles
//   const originalWidth = element.style.width;
//   const originalHeight = element.style.height;
//   const originalMinHeight = element.style.minHeight;
//   const originalMaxWidth = element.style.maxWidth;

//   try {
//     // Use a fixed width for consistent PDF generation across devices
//     element.style.setProperty("width", "360px", "important");
//     element.style.setProperty("max-width", "360px", "important");
//     element.style.setProperty("height", "auto", "important");
//     element.style.setProperty("min-height", "0", "important");

//     // Allow the browser to apply the temporary styles
//     await new Promise((resolve) => requestAnimationFrame(resolve));

//     const scale = 2;

//     const canvas = await html2canvas(element, {
//       scale,
//       useCORS: true,
//       backgroundColor: "#ffffff",
//     });

//     const imgData = canvas.toDataURL("image/png");

//     const pdf = new jsPDF({
//       orientation: "portrait",
//       unit: "pt",
//       format: "a4",
//     });

//     const pdfWidth = pdf.internal.pageSize.getWidth();
//     const pdfHeight = pdf.internal.pageSize.getHeight();

//     const imgHeight = (canvas.height * pdfWidth) / canvas.width;

//     const margin = 10;

//     const renderHeight =
//       imgHeight > pdfHeight - margin * 2
//         ? pdfHeight - margin * 2
//         : imgHeight;

//     pdf.addImage(
//       imgData,
//       "PNG",
//       0,
//       margin,
//       pdfWidth,
//       renderHeight
//     );

//     pdf.save(
//       `Lumina26-${eventDetails.city}-Entry-Pass-EMP${employeeId}.pdf`
//     );

//     setIsSaved(true);
//   } catch (error) {
//     console.error("Error generating PDF", error);
//   } finally {
//     // Restore original responsive styles
//     element.style.width = originalWidth;
//     element.style.height = originalHeight;
//     element.style.minHeight = originalMinHeight;
//     element.style.maxWidth = originalMaxWidth;

//     setIsSaving(false);
//   }
// };

const handleDownloadPDF = async () => {
  setIsSaving(true);
  setIsSaved(false);

  if (!entryPassRef.current) {
    setIsSaving(false);
    return;
  }

  const element = entryPassRef.current;

  try {
    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      backgroundColor: "#ffffff",
      onclone: (clonedDocument) => {
        const clonedElement = clonedDocument.querySelector(".ticket-back");

        if (clonedElement) {
          clonedElement.style.setProperty(
            "border",
            "2px dashed #ccc",
            "important"
          );

          clonedElement.style.setProperty(
            "border-radius",
            "16px",
            "important"
          );

          clonedElement.style.setProperty(
            "box-sizing",
            "border-box",
            "important"
          );

          clonedElement.style.setProperty(
            "height",
            "auto",
            "important"
          );

          clonedElement.style.setProperty(
            "min-height",
            "540px",
            "important"
          );
        }

        const clonedCard = clonedDocument.querySelector(".ticket-card.flipped");

        if (clonedCard) {
          clonedCard.style.setProperty(
            "height",
            "auto",
            "important"
          );

          clonedCard.style.setProperty(
            "min-height",
            "540px",
            "important"
          );

          clonedCard.style.setProperty(
            "overflow",
            "visible",
            "important"
          );
        }
      },
    });

    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "pt",
      format: "a4",
    });

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    const margin = 20;

    // Keep the captured pass aspect ratio
    const maxWidth = pdfWidth - margin * 2;
    const maxHeight = pdfHeight - margin * 2;

    const widthRatio = maxWidth / canvas.width;
    const heightRatio = maxHeight / canvas.height;

    const ratio = Math.min(widthRatio, heightRatio);

    const renderWidth = canvas.width * ratio;
    const renderHeight = canvas.height * ratio;

    // Center horizontally and vertically
    const x = (pdfWidth - renderWidth) / 2;
    const y = (pdfHeight - renderHeight) / 2;

    pdf.addImage(
      imgData,
      "PNG",
      x,
      y,
      renderWidth,
      renderHeight
    );

    pdf.save(
      `Lumina26-${eventDetails.city}-Entry-Pass-EMP${employeeId}.pdf`
    );

    setIsSaved(true);

  } catch (error) {
    console.error("Error generating PDF", error);
  } finally {
    setIsSaving(false);
  }
};

// const handleDownloadPDF = async () => {
//   setIsSaving(true);
//   setIsSaved(false);

//   if (!entryPassRef.current) {
//     setIsSaving(false);
//     return;
//   }

//   const element = entryPassRef.current;
//     // Store existing styles so they can be restored after PDF generation
//   const originalWidth = element.style.width;
//   const originalHeight = element.style.height;
//   const originalMinHeight = element.style.minHeight;
//   const originalMaxWidth = element.style.maxWidth;
  

//   try {
//         // Use a fixed capture width so Laptop and Mobile generate the same PDF layout
//     element.style.setProperty("width", "360px", "important");
//     element.style.setProperty("max-width", "360px", "important");
//     element.style.setProperty("height", "auto", "important");
//     element.style.setProperty("min-height", "0", "important");
//         // Allow browser to apply the temporary styles before capturing
//     await new Promise((resolve) => requestAnimationFrame(resolve));

//     // Use devicePixelRatio for better quality on mobiles
//     const scale =  2;
//      const canvas = await html2canvas(element, {
//       scale,
//       useCORS: true,
//       backgroundColor: "#ffffff"
//     });
//     const imgData = canvas.toDataURL("image/png");
//     const pdf = new jsPDF({
//       orientation: "portrait",
//       unit: "pt",
//       format: "a4",
//     });

//     const pdfWidth = pdf.internal.pageSize.getWidth();
//     const pdfHeight = pdf.internal.pageSize.getHeight();
//     const imgHeight = (canvas.height * pdfWidth) / canvas.width;

//     const margin = 10; // margin to avoid clipping

//     // Limit image height inside PDF page height with margin
//     const renderHeight = imgHeight > (pdfHeight - margin * 2) ? (pdfHeight - margin * 2) : imgHeight;

//     pdf.addImage(imgData, "PNG", 0, margin, pdfWidth, renderHeight);
//     pdf.save(`Lumina26-${eventDetails.city}-Entry-Pass-EMP${employeeId}.pdf`);
//     setIsSaved(true);
//   } catch (error) {
//     console.error("Error generating PDF", error);
//   } finally {
//         // Restore the original responsive styles
//     element.style.width = originalWidth;
//     element.style.height = originalHeight;
//     element.style.minHeight = originalMinHeight;
//     element.style.maxWidth = originalMaxWidth;
//     setIsSaving(false);
//   }
// };

  useEffect(() => {
  if (!employeeId || !email) {
    setQrCode(null);
    setEmployeeName('');
    setError(null)
  }
}, [employeeId, email]);

  if (!eventDetails) {
    return (
      <div className="event-container">
        <div className="error-message">
          Invalid event city. Please check the URL and try again.
        </div>
      </div>
    );
  }

  return (
    <div className="event-container">
      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
        .spinner-icon {
          display: inline-block;
          width: 12px;
          height: 12px;
          border: 2px solid currentColor;
          border-top-color: transparent;
          border-radius: 50%;
          animation: spin 0.8s linear infinite;
          margin-right: 6px;
          vertical-align: middle;
        }
      `}</style>
      {/* Left Panel - Credentials */}
      <div className="left-pane">
        <div className={`ticket-card ${(qrCode || employeeName) && !isFlipping ? "flipped" : ""}`}>
          <div className="ticket-front">
            <div className="logo-container">
              <img src={sutherlandLogo} alt="Company Logo" />
            </div>
            <div className="form-section">
              <div className="radio-group">
                <label>
                  <input
                    type="radio"
                    name="validationType"
                    value="id"
                    checked={validationType === "id"}
                    onChange={handleInputChange}
                  />
                  Employee ID
                </label>

                <label>
                  <input
                    type="radio"
                    name="validationType"
                    value="email"
                    checked={validationType === "email"}
                    onChange={handleInputChange}
                  />
                  Employee Email
                </label>
              </div>
              {validationType === "id" && (
                <input
                  name="employeeId"
                  type="text"
                  placeholder="Emp. ID"
                  value={employeeId}
                  onChange={handleInputChange}
                  disabled={!!email}
                />
              )}
              {validationType === "email" && (
                <>
                  <input
                    type="email"
                    name="email"
                    placeholder="Emp. Email"
                    value={email}
                    onChange={handleInputChange}
                    disabled={!!employeeId}
                  />
                  {emailError && <div className="error-message">{emailError}</div>}
                </>
              )}
              <button onClick={handleValidate} disabled={loading ||
                (validationType === "id" && !employeeId.trim()) ||
                (validationType === "email" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))}>
                {loading ? "Generating..." : "Generate entry pass"}
              </button>
              {error && <div className="error-message">{error}</div>}
            </div>
          </div>

          <div className="ticket-back" ref={entryPassRef}>
            <div className="pass-content">
              <div className="entry-pass-header">Entry Pass</div>
              <div className="event-logo-block">
                <img src={eventLogo} alt="Lumina Logo" className="event-logo" />
              </div>

              <div className="scan-banner">
                <BiQrScan className="scan-banner-icon" />
                <span>Scan this QR code at the venue for entry</span>
              </div>

              <div className="qr-details-row">
                <div className="qr-wrapper visible">
                  <div className="qr-section">
                    <div className="qr-row">
                      <img src={qrCode} alt="QR Code" className="qr-image" />
                    </div>
                  </div>
                </div>

                <div className="qr-divider" />

                <div className="employee-details-right">
                  <div className="employee-name employee-name-with-icon">
                    <FiUser className="employee-name-icon" />
                    <span>{employeeName}</span>
                  </div>
                  {/* <div className="employee-role">Employee</div> */}
                  <div className="detail-row">
                    <FiCalendar className="detail-icon" />
                    <span className="detail-date">{eventDetails.date}</span>
                  </div>
                  <div className="detail-row">
                    <FiClock className="detail-icon" />
                    <span className="detail-time">{eventDetails.time}</span>
                  </div>
                  <div className="detail-row location">
                    <FiMapPin className="detail-icon" />
                    <span className="detail-location">
                      <span className="venue-name">{eventDetails.venue}</span>
                      <span className="venue-address">{eventDetails.address}</span>
                    </span>
                  </div>
                </div>
              </div>

              <div className="footer-info">
                <p className="scan-instruction">
                  Please present this pass for scan at: Bus | Venue
                </p>
                <img src={sutherlandLogo} alt="Company Logo" className="footer-logo" />
                <p className="powered">
                  Developed by <img src={eSeallogo} alt="eSeal Logo" className="powered-logo" /> eSeal Team
                </p>
            <div className="ticket-buttons">
              <button className="save-btn" data-html2canvas-ignore="true"
                onClick={handleDownloadPDF}
                disabled={!qrCode || isSaving}
              >
                {isSaving ? (
                  <>
                    <span className="spinner-icon" />
                    Saving...
                  </>
                ) : (
                  "Save"
                )}
              </button>
              <button className="back-btn" data-html2canvas-ignore="true" onClick={() => {
                setIsFlipping(true);
                setTimeout(() => {
                  setQrCode(null);
                  setEmployeeName("");
                  setIsSaving(false);
                  setIsSaved(false);
                  setIsFlipping(false);
                }, 500);
              }}>Back</button>
            </div>
              </div>
            </div>

          </div>
        </div>
      </div>




      {/* Right Panel - Event Details */}
      <div className="right-pane">
        <div className="event-card">
          <img src={eventLogo} className="logo-badge" alt="Lumina Logo" />
          <div className="event-title">SUTHERLAND DES Annual Day 2026 - {eventDetails.city}</div>
          <div className="event-tagline">An evening of sparkle and spirit!</div>
          <div className="event-info-block">
            <div className="info-row"><FiCalendar className="event-icon" /><span className="label">{eventDetails.date}</span></div>
            <div className="info-row"><FiClock className="event-icon" /><span className="label">{eventDetails.time}</span></div>
            <div className="info-row location">
              <FiMapPin className="event-icon" />
              <span className="label">
                <span className="venue-name">{eventDetails.venue}</span>
                <span className="address">{eventDetails.address}</span>
              </span>
            </div>
          </div>
          <div className="event-highlight">Exciting games performances that promise to dazzle!</div>
        </div>
      </div>

    </div>
  );
}